/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_No_Area_CodeInputs */

const vi_grower_area_qr_no_area_code = /** @type {(inputs: Grower_Area_Qr_No_Area_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng này chưa có mã nên chưa tạo được mã QR.`)
};

/**

* @param {Grower_Area_Qr_No_Area_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_no_area_code = /** @type {((inputs?: Grower_Area_Qr_No_Area_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_No_Area_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_no_area_code(inputs)
});